import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/chat/skills/new/page';

export const Route = createFileRoute('/_app/_chat/skills/new/')({
  component: Page,
});
